import { ExceptionWeights } from "@/enums/exceptions/exception-weights"
import { BaseException } from "@/exceptions/base-exception.exception"

export class NoReassignWithFeedbackException extends BaseException {
  exceptionId = "NO_REASSIGN_WITH_FEEDBACK"
  title = "Instructie opnieuw toewijzen niet mogelijk"
  weight = ExceptionWeights.WARNING

  constructor() {
    super()
  }

  public getMessage() {
    return "Deze instructie kan niet opnieuw worden toegewezen omdat de dienstverlener al feedback heeft gegeven."
  }
}
